// @flow
import {Typography, makeStyles} from '@material-ui/core';
import {Info} from '@material-ui/icons';
import React from 'react';
import {colors} from '../../../../assets/styles/colors';

type Props = {};

const useStyles = makeStyles(theme => ({
  advice: {
    borderRadius: 12,
    backgroundColor: '#F9F9FB',
    padding: theme.spacing(1.5),
    '& p': {
      fontSize: 14,
      color: colors.grey800,
      fontWeight: 500,
    },
    margin: theme.spacing(4, 0, 1, 0),
    [theme.breakpoints.down('md')]: {
      background: 'white',
    },
  },
  content: {
    display: 'flex',
    gap: '12px',
  },
  infoIcon: {
    color: colors.primary,
  },
}));

const PreOrderAdvice = (props: Props) => {
  const classes = useStyles();
  return (
    <div className={classes.advice}>
      <div className={classes.content}>
        <Info className={classes.infoIcon} />
        <Typography>
          El stock de los productos en esta orden ya fue ajustado al crear el
          pre pedido. Cancela el pedido para recuperar el stock.
        </Typography>
      </div>
    </div>
  );
};

export default PreOrderAdvice;
